import { TIMING_LAYERING_METHODOLOGY_ID } from './relationshipTimingInterpretation.js';

export const TIMING_LAYERING_METHODOLOGY = Object.freeze({
  id: TIMING_LAYERING_METHODOLOGY_ID,
  sourceId: 'SRC-ZWDS-BOOK-001',
  sourceLocator: '卷三・論二限太歲吉凶',
  coreLayers: Object.freeze(['decadal', 'minor', 'yearly'] as const),
  normalizedPrinciple: '時間判讀不可把單一流年或單一時間層孤立成高強度結論；應保留大限、小限、流年（太歲）及其交互條件 Evidence，再由明確規則整合。',
  productRestriction: '此方法論只約束 Evidence 組合方式，不把古籍吉凶、禍福或必然事件語句直接轉成現代預測。',
});

export function timingMethodologyViewModel() {
  return Object.freeze({
    id: TIMING_LAYERING_METHODOLOGY.id,
    label: '多時間層合參',
    coreLayers: TIMING_LAYERING_METHODOLOGY.coreLayers,
    sourceId: TIMING_LAYERING_METHODOLOGY.sourceId,
    sourceLocator: TIMING_LAYERING_METHODOLOGY.sourceLocator,
    explanation: '正式 Timing Rule 必須把時間層 Evidence 分開保存；單一流年訊號不能自行升格成高強度事件結論。',
  });
}
